<template>
    <div>
        <action-row>
            <my-btn type="new" @click="addHandler()">设置资格审查内容</my-btn>
        </action-row>

        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="标段名称" prop="by1" fixed min-width="200"></el-table-column>
            <el-table-column label="标段编码" prop="bdcode" min-width="240"></el-table-column>
            <el-table-column label="操作" width="500" fixed="right">
                <template slot-scope="scope">
                    <my-btn
                    type="edit"
                    @click="editHandler(scope.row.bdcode)">
                        资格审查内容详情
                    </my-btn>
                </template>
            </el-table-column>
        </my-table>

        <my-pagination
            ref="page"
            v-model="tableData"
            :search="pgData"
            :action="`${getGetters('bidUrl')}/Zbdl/zgsc/xingtai/getnrlist.json`">
        </my-pagination>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'

export default {
    mixins: [ LIST_PAGE_MIXIN ],
    components: { },
    data() {
        return {
            pgData: {
                sortname: 'bdcode',
                zbprocode: this.getQuery('zbprocode')
            },
            zbprocode:'',
            model: {}
        }
    },
    computed: {
        procode() {
            return this.getQuery('procode')
        }
    },
    methods: {
        editHandler(bdcode){
            this.goto({
                path:'./form',
                query:{
                    zbprocode:this.pgData.zbprocode,
                    bdcode:bdcode
                }
            });
        },
        addHandler() {   
            this.goto({
                path:'./form',
                query:{
                    zbprocode:this.zbprocode,
                },
            });   
        }
    },
    created() {
        this.jspInit(`${this.getGetters('bidUrl')}/Zbdl/zgsc/xingtai/setzgscnrlist.json`, {
            zbprocode: this.pgData.zbprocode
        }, data => {
            this.zbprocode=data.zbprocode
            
        });
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">
</style>
